module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.f6b8d6f8.jpeg";